import SwitchButton from './component'

export default SwitchButton
